import { SubaccountAdminData } from "~frontend/providers/LoggedInUserProvider/context";

import { CampaignForView } from "./types";

export const shouldShowClicks = (
  variant: CampaignForView["scriptVariants"][0] & { clickCount?: number },
  subaccount: SubaccountAdminData
): boolean => {
  if (variant.clickCount && variant.clickCount > 0) {
    // we have tracked clicks
    return true;
  } else if (variant.overrideLinkShortenerSettings) {
    // variant using its own settings
    return !!variant.linkShortenerDomainName;
  } else {
    // variant using subaccount settings
    return !!subaccount.defaultLinkShortenerDomainName;
  }
};
